import {companyDayKey, DayKey, dayKeyToPickerDate} from "../../../../_shared/time/company-day";

/**
 * A dot on the month picker.
 *
 * The picker grid is built from browser-local dates and matches entries to cells by `toLocaleDateString()`. The
 * entry is placed on the COMPANY calendar day of its start (#656): `strStart` is the local date string of that
 * day, not of the raw instant — so an event at 01:00 Berlin on 01.08. sits on 01.08. for every viewer, even one
 * whose browser still says 31.07.
 */
export class CalendarEntry {
  id: string;
  start: Date;
  /** The company calendar day the entry is placed on. */
  day: DayKey;
  strStart: string;
  end: Date;
  color: string = "#4c4c4c";

  constructor(start: Date, end: Date, color: string = "#4c4c4c", id: string = "", timeZone: string) {
    this.start = new Date(start);
    this.end = new Date(end);
    this.day = companyDayKey(this.start, timeZone);
    this.strStart = dayKeyToPickerDate(this.day).toLocaleDateString();
    this.color = color;
    this.id = id;
  }
}
